import request from '../../../Helpers/Request';

class CustomerGroups {
    constructor(settings) {
        this.settings = settings;
    }

    getCustomerGroups(connectionId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${connectionId}/customer-groups`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    getRules(connectionId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${connectionId}/customer-groups/rules`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    index(connectionId, page) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${connectionId}/customer-groups/index?page=${page}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    show(connectionId, customerGroupId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${connectionId}/customer-groups/${customerGroupId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    store(connectionId, data) {
        return new Promise((resolve, reject) => {
            request('POST', `/clients/connections/${connectionId}/customer-groups`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    update(connectionId, customerGroupId, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/clients/connections/${connectionId}/customer-groups/${customerGroupId}`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    destroy(connectionId, customerGroupId) {
        return new Promise((resolve, reject) => {
            request('DELETE', `/clients/connections/${connectionId}/customer-groups/${customerGroupId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default CustomerGroups;
